import { AustralianState } from '@urbanx/agx-ui-components';
import { AgxApi } from '../../helpers/http';
import {
  AllPropertyDetails,
  PropertySuggestionResponse,
  PropertySummaryResponseModel,
  SuburbSuggestionResponse,
  VendorDetailsResponseModel,
} from './Types/types';

export const rpDataApi = (authToken: string) => new AgxApi('rpdata', authToken);

export const fetchAddresses = async (
  authToken: string,
  query: string,
  state: string,
  signal: AbortSignal
): Promise<PropertySuggestionResponse | null> => {
  const { data } = await rpDataApi(authToken).get<PropertySuggestionResponse>(
    'AddressSuggestion',
    {
      query,
      state,
    },
    signal
  );
  return data;
};

export const fetchPlanSuggestions = async (
  authToken: string,
  query: string,
  state: AustralianState,
  signal: AbortSignal
): Promise<PropertySuggestionResponse | null> => {
  const { data } = await rpDataApi(authToken).get<PropertySuggestionResponse>(
    'PlanSuggestion',
    {
      query,
      state,
    },
    signal
  );
  return data;
};

export const fetchPropertyDetails = async (
  authToken: string,
  propertyId: number
): Promise<AllPropertyDetails | null> => {
  try {
    const [propertySummaryResponse, vendorDetailsResponse] = await Promise.all([
      rpDataApi(authToken).get<PropertySummaryResponseModel>('GetPropertySummary', {
        PropertyId: propertyId,
      }),
      rpDataApi(authToken).get<VendorDetailsResponseModel>('GetVendorDetails', {
        PropertyId: propertyId,
      }),
    ]);

    const { status: propertySummaryStatus, data: propertySummary } = propertySummaryResponse;
    const { status: vendorDetailsStatus, data: vendorDetails } = vendorDetailsResponse;

    if (propertySummaryStatus === 200 && vendorDetailsStatus === 200) {
      return {
        ...propertySummary,
        ...vendorDetails,
      };
    }
  } catch (err) {
    console.error(err);
  }

  return null;
};

export const fetchSuburbSuggestions = async (
  authToken: string,
  query: string,
  state: string,
  signal: AbortSignal
): Promise<SuburbSuggestionResponse | null> => {
  const { data } = await rpDataApi(authToken).get<SuburbSuggestionResponse>(
    'SuburbSuggestion',
    {
      query,
      state,
    },
    signal
  );
  return data;
};
